import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const http = axios.create({ baseURL: API, timeout: 240000 });

export const PREMIUM_PRICE = "4,90 €";

export const eur = (n) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(Number(n) || 0);

const IMG = {
  chateau: "https://images.unsplash.com/photo-1787386046626-561f43cb68bb?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600",
  cottage: "https://images.unsplash.com/photo-1778158257031-053db0607bac?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
  farm: "https://images.unsplash.com/photo-1778158257064-e8603dc1105a?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
  train: "https://images.unsplash.com/photo-1673086636059-0f4abc8b853b?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
  bistro: "https://images.unsplash.com/photo-1775122939819-b36403bcaad4?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
  dining: "https://images.unsplash.com/photo-1766847733845-6b2eaee1043b?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200",
};
export const HERO_IMG = IMG.chateau;
export const TRAIN_IMG = IMG.train;

const POOLS = {
  mer: ["https://images.unsplash.com/photo-1608814966756-0770663dbf16?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200", "https://images.unsplash.com/photo-1499310182723-e1c1b04bbaf8?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200"],
  vigne: ["https://images.unsplash.com/photo-1729799635070-cd0c54160d9c?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200", "https://images.unsplash.com/photo-1703113690550-b1c65a730cd3?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200", "https://images.unsplash.com/photo-1729799618381-808e444dc4c4?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200"],
  village: ["https://images.unsplash.com/photo-1772880582625-69f654b3bdec?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200", "https://images.unsplash.com/photo-1759477836151-275cde32a968?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200", "https://images.unsplash.com/photo-1775471167485-0a4509172365?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200", IMG.chateau],
  nature: ["https://images.unsplash.com/photo-1625905787174-374f5cd14a9a?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200", "https://images.unsplash.com/photo-1581878879399-c933ccf51c36?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200", IMG.farm],
  gastro: [IMG.bistro, IMG.dining],
  bien: [IMG.cottage, IMG.farm],
};

const RULES = [
  ["mer", /plage|mer\b|océan|ocean|bassin|côte|cote|dune|littoral|port\b|baie|île|ile\b/],
  ["vigne", /vign|vin\b|vins|cru|œno|oeno|vendange|champagne/],
  ["gastro", /gastro|cuisine|table|saveur|marché/],
  ["bien", /bien-être|spa|thermal|thermes|détente/],
  ["village", /patrimoine|culture|médiév|medieval|château|chateau|village|cité|abbaye|cathédrale/],
  ["nature", /nature|forêt|foret|randonn|montagne|vallée|gorge|lac|aventure/],
];

const hash = (str = "") => [...str].reduce((h, c) => (h * 31 + c.charCodeAt(0)) >>> 0, 7);

export const imageFor = (e = {}) => {
  const head = `${e.title || ""} ${e.angle || ""}`.toLowerCase();
  const body = (e.summary || "").toLowerCase();
  const match = RULES.find(([, re]) => re.test(head)) || RULES.find(([, re]) => re.test(body)) || ["village"];
  const pool = POOLS[match[0]];
  return pool[hash(e.destination || e.title) % pool.length];
};

export const isDayTrip = (e) => e.duration === 1 || !Number(e.accommodation?.price_per_night);
